import { BaseScopableEntityService } from '/@/modules/core/app/services/abstracts/BaseScopableEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { User } from '/@/modules/user/models/User';
import { BaseModelType } from '@/modules/core/app/models/abstracts/BaseModel';

export class UserTimeEntryService extends BaseScopableEntityService<User> {
  getRoute(): Route {
    return Route.USERS_TIMEENTRIES;
  }

  getModel(): BaseModelType<User> {
    return User;
  }
}

export default new UserTimeEntryService();
